export default "__VITE_ASSET__9FRwp4zz__"